import { PION_TYPES_DATA } from '../../../../../../constants/tasks';

const useMutateCardPions = () => {
  const addPion = (fieldArrayHelpers, pionType) => {
    fieldArrayHelpers.push(PION_TYPES_DATA[pionType]);
  };

  const removePion = (fieldArrayHelpers, index) => {
    fieldArrayHelpers.remove(index);
  };

  return { addPion, removePion };
};

export default useMutateCardPions;
